import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';

export type ResponseData<T> = {
  data: T;
  success: boolean;
  draw?: number | null;
  recordsTotal?: number | null;
  recordsFiltered?: number | null;
  errorMessage?: string | null;
  currentPage?: number | null;
  totalItems?: number | null;
  totalPages?: number | null;
};

const buildConfig = () => {
  const token = sessionStorage.getItem('token');
  return {
    headers: token ? { Authorization: `${ACCESS_TYPE} ${token}` } : undefined,
  };
};

export type DriverRouteSnapshot = {
  driversInRoute: number;
  driversScheduled: number;
  routesInProgress: number;
  routesFinished: number;
  clientsVisited: number;
  clientsTotal: number;
  vmsServiced: number;
  vmsTotal: number;
};

export type DriverRouteRow = {
  routeServiceId: number;
  routeScheduleId: number | null;
  routeName: string | null;

  driverUserId: number | null;
  driverFirstName: string | null;
  driverLastName: string | null;

  routeStatus: number | null;

  // Optional - if backend sends them (safe to keep nullable)
  startTime: string | null;
  elapsedMinutes: number | null;

  clientsVisited: number | null;
  clientsTotal: number | null;

  vmsServiced: number | null;
  vmsTotal: number | null;
};

export type DriverRouteProgressResponse = {
  snapshot: DriverRouteSnapshot;
  routes: DriverRouteRow[];
};

export const fetchDriverRouteProgressSnapshot = () => {
  const url = `${VENDING_URL}driver/route-progress-snapshot`;
  return axios.get<ResponseData<DriverRouteProgressResponse>>(url, buildConfig());
};
